<template>
    <div class="embed-slider-wrapper pl-3 pr-3" :style="
        'background-color: ' + ((widget_data.widget.settings.background_type == 'Transparent') ? 'transparent' : widget_data.widget.settings.background_color) + ';' +
        'margin-left: -' + widget_data.widget.settings.padding_between_reviews + ';'
    ">
        <div style="position: relative; box-sizing: border-box; height: 280px;">
            <div style="position: absolute; width: 300px; border: solid 1px #CCCCCC; padding-top: 20px; text-align: center; min-height: 250px; height: calc(100% - 40px); margin-top: 4px;">
                <Header :widget_data="widget_data" />

                <v-rating
                    class="reviews-rating -mt-3 mb-6"
                    :value="parseFloat(widget_data.average_rating)"
                    :color="widget_data.widget.settings.star_color"
                    dense
                    half-increments
                    readonly
                    size="35"
                ></v-rating>

                <div v-show="widget_data.widget.settings.show_leave_a_review_button == 1" class="pt-0 mb-5" style="width: 160px; margin: auto;">
                    <div class="border-1 border-blue text-primary text-xs text-bold px-4 py-2 rounded cursor-pointer" @click="openReviewFunnel()" style="margin-top: -5px;"><i class="fa fa-star mr-2"> </i> WRITE A REVIEW</div>
                </div>
            </div>

            <div style="position: absolute; margin-left: 300px; padding-left: 20px; min-height: 250px">
                <v-carousel height="280">
                    <template v-for="(item, index) in widget_data.reviews"> 
                    <v-carousel-item v-if="(index + 1) % slider_columns === 1 || slider_columns === 1" 
                                    :key="index"
                                    style="height: 100%;"
                    > 
                        <v-row class="flex-nowrap" style="height: 100%;"> 
                        <template v-for="(n,i) in slider_columns"> 
                            <template v-if="(+index + i) < widget_data.reviews.length"> 
                            <v-col :key="i" style="height: 100%;">
                                <v-sheet v-if="(+index + i) < widget_data.reviews.length" 
                                        height="100%"
                                        color="transparent"
                                >
                                    <Review :widget_data="widget_data" :item="widget_data.reviews[+index + i]" />
                                </v-sheet>
                            </v-col> 
                            </template> 
                        </template> 
                        </v-row> 
                    </v-carousel-item> 
                    </template> 
                </v-carousel>
            </div>

            <div class="clearfix"></div>
        </div>
    </div>
</template>

<script>
import Header from '@/views/panel/Business/Widgets/Render/Header.vue';
import HeaderAggregate from '@/views/panel/Business/Widgets/Render/HeaderAggregate.vue';
import Review from '@/views/panel/Business/Widgets/Render/Review.vue';

export default {
    props: ["widget_data", "fw"],

    components: {
        Header,
        HeaderAggregate,
        Review
    },

    methods: {
        openReviewFunnel() {
            window.open(this.widget_data.review_funnel_link);
        }
    },

    computed: {
        slider_columns() {
            if (this.widget_data.widget.settings.reviews_per_page < 3)
                return parseInt(this.widget_data.widget.settings.reviews_per_page);

            // return 3;

            if (this.$vuetify.breakpoint.xl) {
                return 3;
            }

            if (this.$vuetify.breakpoint.lg) {
                return 2;
            }

            if (this.$vuetify.breakpoint.md) {
                return 1;
            }

            return 1;
        }
    },

    mounted() {
        console.log('mountddddd');
    }
}
</script>

<style type="text/css" scoped>
    .embed-slider-wrapper {
        width: 100%;
        padding-bottom: 10px;
    }

    .v-carousel__controls {
        display: none !important;
    }

    .embed-slider-wrapper .v-window-item {
        padding-left: 50px;
        padding-right: 50px;
    }
</style>